import { get } from 'lodash';
import DatadogHandler from 'utils/datadog';
import { actionHandlerWithFeatureFlag } from 'utils';
import { FEATURE_FLAGS } from 'utils/constants';
import {
  msApproveECDARegDocument,
  msGetECDARegistratgionDocumentUploadURL,
  msGetECDARegistrationTncUploadURL,
  msGetECDARegUploadDocumentList,
  msRejectECDARegDocument,
  msSkipECDARegDocument,
  msSubmitECDARegForm,
  msRemoveECDARegUploadedDocument,
  msRevertECDARegDocument,
} from 'services/RegistrationsService';
import { FETCH_ECDA_REG_DOCUMENTS_TO_UPLOAD } from '../actionTypes';

import {
  SUBMIT_ECDA_REG_FORM,
  REVERT_ECDA_REG_DOCUMENT,
  REMOVE_ECDA_REG_DOCUMENT,
  APPROVE_ECDA_REG_DOCUMENT,
  REJECT_ECDA_REG_DOCUMENT,
  SKIP_ECDA_REG_DOCUMENT,
  GET_ECDA_REG_DOCUMENT_UPLOAD_URL,
  GET_ECDA_REGISTRATION_DOCUMENT_LIST,
  GET_ECDA_REG_TNC_UPLOAD_URL,
} from '../../models/documentModelsECDA';
import { SkApolloRequest } from '../../../utils/apolloUtils';

const fileName = 'src/redux/actions/Registration/DocumentECDA.js';

const dispatchDocumentUploadList = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ECDA_REG_DOCUMENTS_TO_UPLOAD,
    key: 'documentsToUpload',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

export const monoGetECDARegUploadDocumentList = async (_, reqData) => {
  try {
    const IDECDARegistration = get(reqData, 'IDECDARegistration');
    return SkApolloRequest({
      params: {
        query: GET_ECDA_REGISTRATION_DOCUMENT_LIST,
        variables: { IDECDARegistration },
      },
      type: 'query',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetECDARegUploadDocumentList',
        fileName,
      },
      'error'
    );
    const errorMessage = ex.message.replace(/GraphQL error./, '');
    return { error: errorMessage };
  }
};

export const getECDARegUploadDocumentList =
  IDECDARegistration => async dispatch => {
    dispatchDocumentUploadList(dispatch);

    const resp = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetECDARegUploadDocumentList,
        monoHandler: monoGetECDARegUploadDocumentList,
        extraData: { IDECDARegistration },
      }
    );

    if (resp.success) {
      dispatchDocumentUploadList(dispatch, false, resp.data);
    } else {
      dispatchDocumentUploadList(dispatch, false, null, resp.error);
    }

    return resp;
  };

export const monoGetECDARegistratgionDocumentUploadURL = async (_, reqData) => {
  try {
    const IDECDARegistration = get(reqData, 'IDECDARegistration');
    const file = get(reqData, 'file');
    return SkApolloRequest({
      params: {
        mutation: GET_ECDA_REG_DOCUMENT_UPLOAD_URL,
        variables: {
          IDECDARegistration,
          file,
        },
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetECDARegistratgionDocumentUploadURL',
        fileName,
      },
      'error'
    );
    const errorMessage = ex.message.replace(/GraphQL error./, '');
    return { error: errorMessage };
  }
};

export const getECDARegistrationDocumentUploadURL =
  (IDECDARegistration, file) => async () => {
    return actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        monoHandler: monoGetECDARegistratgionDocumentUploadURL,
        msHandler: msGetECDARegistratgionDocumentUploadURL,
        extraData: { IDECDARegistration, file },
      }
    );
  };

export const monoRemoveECDARegUploadedDocument = async (_, reqData) => {
  try {
    const { IDECDARegistration, IDDocument, remarks } = reqData;
    const response = await SkApolloRequest({
      params: {
        mutation: REMOVE_ECDA_REG_DOCUMENT,
        variables: {
          ecdaRegistrationId: IDECDARegistration,
          documentId: IDDocument,
          remarks,
        },
      },
      type: 'mutation',
    });

    return response;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoRemoveECDARegUploadedDocument',
        fileName,
      },
      'error'
    );
    const errorMessage = ex.message.replace(/GraphQL error./, '');
    return { error: errorMessage };
  }
};

export const removeECDARegUploadedDocument =
  (IDECDARegistration, IDDocument, remarks) => async () => {
    return actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msRemoveECDARegUploadedDocument,
        monoHandler: monoRemoveECDARegUploadedDocument,
        extraData: { IDECDARegistration, IDDocument, remarks },
      }
    );
  };

export const monoApproveECDARegDocument = async (_, reqData) => {
  try {
    const IDECDARegistration = get(reqData, 'IDECDARegistration');
    const IDDocumentType = get(reqData, 'IDDocumentType');
    const remarks = get(reqData, 'remarks');
    return SkApolloRequest({
      params: {
        mutation: APPROVE_ECDA_REG_DOCUMENT,
        variables: {
          ecdaRegistrationId: IDECDARegistration,
          documentTypeId: IDDocumentType,
          remarks,
        },
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoApproveECDARegDocument',
        fileName,
      },
      'error'
    );
    const errorMessage = ex.message.replace(/GraphQL error./, '');
    return { error: errorMessage };
  }
};

export const approveECDARegDocument = async (
  IDECDARegistration,
  IDDocumentType,
  remarks
) => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msApproveECDARegDocument,
      monoHandler: monoApproveECDARegDocument,
      extraData: { IDECDARegistration, IDDocumentType, remarks },
    }
  );
};

export const monoRejectECDARegDocument = async (_, reqData) => {
  try {
    const IDECDARegistration = get(reqData, 'IDECDARegistration');
    const IDDocumentType = get(reqData, 'IDDocumentType');
    const remarks = get(reqData, 'remarks');
    return SkApolloRequest({
      params: {
        mutation: REJECT_ECDA_REG_DOCUMENT,
        variables: {
          ecdaRegistrationId: IDECDARegistration,
          documentTypeId: IDDocumentType,
          remarks,
        },
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoRejectECDARegDocument',
        fileName,
      },
      'error'
    );
    const errorMessage = ex.message.replace(/GraphQL error./, '');
    return { error: errorMessage };
  }
};
export const rejectECDARegDocument =
  (IDECDARegistration, IDDocumentType, remarks) => async () => {
    return actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        monoHandler: monoRejectECDARegDocument,
        msHandler: msRejectECDARegDocument,
        extraData: { IDECDARegistration, IDDocumentType, remarks },
      }
    );
  };

export const monoSkipECDARegDocument = async (_, reqData) => {
  try {
    const IDECDARegistration = get(reqData, 'IDECDARegistration');
    const IDDocumentType = get(reqData, 'IDDocumentType');
    const remarks = get(reqData, 'remarks');
    return SkApolloRequest({
      params: {
        mutation: SKIP_ECDA_REG_DOCUMENT,
        variables: {
          ecdaRegistrationId: IDECDARegistration,
          documentTypeId: IDDocumentType,
          remarks,
        },
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoSkipECDARegDocument',
        fileName,
      },
      'error'
    );
    const errorMessage = ex.message.replace(/GraphQL error./, '');
    return { error: errorMessage };
  }
};

export const skipECDARegDocument =
  (IDECDARegistration, IDDocumentType, remarks) => async () => {
    return actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msSkipECDARegDocument,
        monoHandler: monoSkipECDARegDocument,
        extraData: { IDECDARegistration, IDDocumentType, remarks },
      }
    );
  };

export const monoRevertECDARegDocument = async (_, reqData) => {
  const { IDECDARegistration, IDDocumentType, remarks } = reqData;
  try {
    const response = await SkApolloRequest({
      params: {
        mutation: REVERT_ECDA_REG_DOCUMENT,
        variables: {
          ecdaRegistrationId: IDECDARegistration,
          documentTypeId: IDDocumentType,
          remarks,
        },
      },
      type: 'mutation',
    });

    return response;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoRevertECDARegDocument',
        fileName,
      },
      'error'
    );

    const errorMessage = ex.message.replace(/GraphQL error./, '');
    return { error: errorMessage };
  }
};

export const revertECDARegDocument =
  (IDECDARegistration, IDDocumentType, remarks) => async () =>
    actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
      msHandler: msRevertECDARegDocument,
      monoHandler: monoRevertECDARegDocument,
      extraData: { IDECDARegistration, IDDocumentType, remarks },
    });

export const monoSubmitECDARegForm = async (_, reqData) => {
  try {
    const IDECDARegistration = get(reqData, 'IDECDARegistration');
    const info = get(reqData, 'info');
    return SkApolloRequest({
      params: {
        mutation: SUBMIT_ECDA_REG_FORM,
        variables: { ecdaRegistrationId: IDECDARegistration, info },
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoSubmitECDARegForm',
        fileName,
      },
      'error'
    );
    const errorMessage = ex.message.replace(/GraphQL error./, '');
    return { error: errorMessage };
  }
};
export const submitECDARegForm = (IDECDARegistration, info) => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msSubmitECDARegForm,
      monoHandler: monoSubmitECDARegForm,
      extraData: { IDECDARegistration, info },
    }
  );
};

export const monoGetECDARegistrationTncUploadURL = async (_, reqData) => {
  try {
    const IDECDARegistration = get(reqData, 'IDECDARegistration');
    const file = get(reqData, 'file');
    return SkApolloRequest({
      params: {
        mutation: GET_ECDA_REG_TNC_UPLOAD_URL,
        variables: {
          IDECDARegistration,
          file,
        },
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetECDARegistrationTncUploadURL',
        fileName,
      },
      'error'
    );
    const errorMessage = ex.message.replace(/GraphQL error./, '');
    return { error: errorMessage };
  }
};

export const getECDARegistrationTncUploadURL = async (
  IDECDARegistration,
  file
) => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      monoHandler: monoGetECDARegistrationTncUploadURL,
      msHandler: msGetECDARegistrationTncUploadURL,
      extraData: { IDECDARegistration, file },
    }
  );
};
